try{self['workbox:sw:6.6.1']&&_()}catch(e){}// eslint-disable-line